export enum OperationSubCategoryEnum {
    SUBCATEGORY_UNKNOWN = 'SUBCATEGORY_UNKNOWN',
    SUBCATEGORY_A1 = 'SUBCATEGORY_A1',
    SUBCATEGORY_A2 = 'SUBCATEGORY_A2',
    SUBCATEGORY_A3 = 'SUBCATEGORY_A3',
}